// extracted by mini-css-extract-plugin
export default {"container":"_f759b81e","label":"_efb3ebff","header":"_545ff506","buffer":"_c4a03c59","content":"_6fc1bdd0"};